import React, { useEffect } from 'react';
import Navbar from './common/Navbar';
import { Outlet } from 'react-router-dom';
import Footer from './common/Footer';
import { isMobile } from 'react-device-detect';
import './ShadowDarkTools.css';
import KoFiButton from './common/KoFiButton';

const KOFI_SCRIPT_URL = 'https://storage.ko-fi.com/cdn/scripts/overlay-widget.js';

function ShadowDarkTools() {
  useEffect(() => {
    if (!document.querySelector(`script[src="${KOFI_SCRIPT_URL}"]`)) {
      const script = document.createElement('script');
      script.src = KOFI_SCRIPT_URL;
      script.async = true;
      script.onload = () => {
        console.log('Ko-fi script loaded');
      };
      document.body.appendChild(script);
    }
  }, []);

  const appClass = isMobile ? 'app-mobile' : 'app';

  return (
    <>
      <div className={appClass}>
        <h1 className="appTitle">Shadowdark Tools</h1>
        <div className="font-face-montserrat-medium">
          <Navbar />
        </div>
        <Outlet />
      </div>
      <div className="kofi-button-container">
        <KoFiButton />
      </div>
      <Footer />
      <br />
      <br />
      <br />
    </>
  );
}

export default ShadowDarkTools;
